const PUSH_DEEP_LINK_FALLBACK_PATHS: Record<string, string> = {
  PUSH_NOTICE_USER: "/customer/layout/inform-detail",
  PUSH_NOTICE_BUSINESS: "/business/layout/notify-detail",
  PUSH_NOTICE: "/customer/layout/inform",
  PUSH_RESERV_CONFIRM_USER: "/customer/layout/calendar-reservation-chg",
  // 취소 푸시도 예약 상세로 — BE 가 cdReservStatus/cdReservType/reservationSeq/companyName 쿼리를 실어 보냄
  PUSH_RESERV_CANCEL_USER: "/customer/layout/calendar-reservation-chg",
  PUSH_RESERV_BUSINESS: "/business/layout/calendar",
  // 계약 — BE 가 path 를 명시로 실어 보내지만, path 누락 시 폴백 경로
  PUSH_CONTRACT_USER: "/customer/layout/contract-sign", // requestSeq 쿼리와 함께 해당 계약 서명 화면
  PUSH_CONTRACT_BIZ: "/business/layout/contract-status", // 사업자 서명 요청 현황
  // 가상계좌 입금 확인 → 크레딧 충전 완료. 충전된 잔액을 바로 보도록 지갑으로.
  PUSH_CREDIT_DEPOSIT_BIZ: "/business/layout/user-credit-wallet",
};

export const getPushDeepLinkFallbackPath = (type?: string): string => {
  if (!type) {
    return "";
  }

  return PUSH_DEEP_LINK_FALLBACK_PATHS[type] || "";
};
